// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import {local} from 'wix-storage';
// import {session} from 'wix-storage';
import wixWindow from 'wix-window';

// $w.onReady(function () {
//   // flag is not found
//   if(!session.getItem("firstTimePopupShown")) {
//     // open popup
//     wixWindow.openLightbox("Announcement");
//     // set flag for future visits
//     session.setItem("firstTimePopupShown", "yes");
//   }
// } );

$w.onReady(function () {
  if(!local.getItem("firstTimePopupShown")) {
    wixWindow.openLightbox("lightboxWelcome");
    local.setItem("firstTimePopupShown", "yes");
  }
} );